<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 500px;")
              div {{ $t('ui.event') }}
            th
              div {{ $tc('ui.odds', 2) }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.ed }}
            td(style="width: 500px;")
              div.text-info {{ item.th }}
              div.text-danger {{ item.ln }}
            td.text-center(style="width: 100px;")
              div(:class="{'up': item.ort_blink }")  {{ item.ort }}
</template>
<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>
